var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningCat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 99,
    viewBox: "0 0 121 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.652 49.1821C120.652 67.0296 111.155 82.66 96.929 91.2696C96.3378 91.6391 95.7465 91.9717 95.1553 92.3042L100.587 51.9535C100.698 51.1405 100.107 50.4015 99.3308 50.2907C98.5179 50.1798 97.7789 50.7341 97.668 51.547L91.9775 93.8931C90.5364 94.5583 89.0584 95.1495 87.5803 95.6668L91.645 51.8796C91.7189 51.0666 91.1276 50.3646 90.3147 50.2907C89.5018 50.2168 88.7627 50.808 88.7258 51.6209L84.5134 96.6275C83.1092 96.997 81.6312 97.3296 80.1901 97.5883L82.4441 51.8057C82.481 50.9927 81.8529 50.2907 81.0399 50.2537C80.227 50.2168 79.5249 50.8449 79.488 51.6579L77.197 98.0317C75.7929 98.1795 74.4257 98.2903 72.9846 98.3273V51.7687C72.9846 50.9558 72.3194 50.2907 71.5065 50.2907C70.6936 50.2907 70.0285 50.9558 70.0285 51.7687V98.3643C68.7352 98.3273 67.4788 98.2534 66.2225 98.1056L63.9315 51.6948C63.8946 50.8819 63.1925 50.2537 62.3796 50.2907C61.5666 50.3276 60.9385 51.0297 60.9754 51.8426L63.2294 97.6991C61.7514 97.4405 60.3103 97.1449 58.9061 96.7753L54.6567 51.6209C54.5828 50.808 53.8808 50.2168 53.0678 50.2907C52.2549 50.3646 51.6637 51.1036 51.7376 51.8796L55.8392 95.8516C54.3242 95.3342 52.8831 94.78 51.442 94.1518L45.7145 51.584C45.6037 50.771 44.8647 50.2168 44.0517 50.3276C43.2388 50.4385 42.6845 51.1775 42.7954 51.9904L48.2272 92.5998C47.5252 92.2303 46.86 91.8608 46.1949 91.4544C31.8578 82.8447 22.2505 67.1404 22.2505 49.1821C22.2505 22.023 44.2734 0 71.4326 0C98.6287 0 120.652 22.023 120.652 49.1821Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9443 52.0885C84.6725 34.5342 84.2904 26.1848 78.8724 18.035C78.804 17.9324 78.6614 17.9096 78.5645 17.9894C77.5037 18.8677 76.3288 20.8068 75.8384 22.8656C74.0134 22.5291 72.1827 22.1812 70.312 22.2953C69.1657 22.3637 68.0365 22.6603 66.9072 22.8656C66.4168 20.8011 65.2476 18.8677 64.1811 17.9894C64.0842 17.9096 63.9416 17.9324 63.8732 18.035C58.4552 26.1848 58.0731 34.5342 56.8013 52.0885L71.3728 50.9137L85.9443 52.0885Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2514 34.0875C64.8028 34.0875 63.4682 33.3004 62.7668 32.0343C62.6014 31.7321 62.7097 31.35 63.012 31.1789C63.3143 31.0135 63.6964 31.1218 63.8675 31.4241C64.3522 32.291 65.2647 32.8328 66.2571 32.8328C67.2494 32.8328 68.1676 32.291 68.6467 31.4241C68.8121 31.1218 69.1942 31.0135 69.5022 31.1789C69.8044 31.3443 69.9128 31.7264 69.7474 32.0343C69.0345 33.3004 67.7 34.0875 66.2514 34.0875Z",
    fill: "#989FB0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5341 34.0875C75.0855 34.0875 73.751 33.3004 73.0495 32.0343C72.8841 31.7321 72.9924 31.35 73.2947 31.1789C73.597 31.0135 73.9791 31.1218 74.1502 31.4241C74.6349 32.291 75.5474 32.8328 76.5398 32.8328C77.5321 32.8328 78.4504 32.291 78.9294 31.4241C79.0948 31.1218 79.4769 31.0135 79.7849 31.1789C80.0872 31.3443 80.1955 31.7264 80.0301 32.0343C79.3172 33.3004 77.9827 34.0875 76.5341 34.0875Z",
    fill: "#989FB0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8483 38.9699C67.8198 38.9699 67.7855 38.9699 67.7513 38.9642L61.3467 37.9946C61.0045 37.9433 60.7707 37.6239 60.822 37.2818C60.8733 36.9396 61.1927 36.7057 61.5349 36.7571L67.9395 37.7266C68.2817 37.7779 68.5155 38.0973 68.4642 38.4395C68.4186 38.7475 68.1505 38.9699 67.8483 38.9699Z",
    fill: "#989FB0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5843 41.6915C62.2592 41.6915 61.9798 41.4406 61.9569 41.1041C61.9341 40.7562 62.1965 40.4597 62.5387 40.4369L67.8027 40.0776C68.1449 40.0547 68.4471 40.3171 68.4699 40.6593C68.4928 41.0072 68.2304 41.3037 67.8882 41.3265L62.6242 41.6858C62.6128 41.6915 62.5957 41.6915 62.5843 41.6915Z",
    fill: "#989FB0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9085 38.9717C74.6062 38.9717 74.3382 38.7493 74.2868 38.4356C74.2355 38.0934 74.4693 37.774 74.8115 37.7227L81.2162 36.7532C81.5584 36.7018 81.8777 36.9357 81.9291 37.2778C81.9804 37.62 81.7466 37.9394 81.4044 37.9907L74.9997 38.9603C74.9712 38.9717 74.9427 38.9717 74.9085 38.9717Z",
    fill: "#989FB0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1725 41.6917C80.1554 41.6917 80.144 41.6917 80.1269 41.6917L74.8629 41.3324C74.515 41.3096 74.2584 41.0073 74.2812 40.6651C74.304 40.3229 74.6006 40.0606 74.9485 40.0834L80.2125 40.4427C80.5604 40.4655 80.817 40.7678 80.7942 41.11C80.7771 41.4408 80.5033 41.6917 80.1725 41.6917Z",
    fill: "#989FB0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1715 37.1244C71.8521 37.0731 70.894 37.0731 70.5689 37.1244C70.2267 37.1815 69.799 37.267 69.9359 38.0655C70.01 38.4989 70.2723 38.881 70.6145 39.1662C71.2191 39.668 71.5156 39.611 71.9947 39.2574C72.3882 38.9723 72.7133 38.5502 72.7988 38.0598C72.9471 37.2613 72.5137 37.1758 72.1715 37.1244Z",
    fill: "#989FB0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7208 7.17236C29.1171 10.1704 37.8423 15.4686 44.6758 22.5856C46.0447 24.1175 47.5747 25.7414 48.1712 27.6914C49.2158 30.5408 48.3472 34.1235 46.2708 36.2662C44.1483 38.4898 40.6913 39.3085 37.6745 38.2318C35.7514 37.6716 34.0602 35.9558 33.844 33.9008C33.7546 31.8107 35.2433 29.7622 37.1909 29.1559C39.2309 28.3876 41.4075 28.8778 43.1341 29.9698C44.8607 31.0619 46.2639 32.7207 47.2869 34.4847C50.7587 40.0063 51.936 47.1169 50.522 53.7154C49.4559 58.5806 46.9157 63.0344 43.4322 66.5209",
    stroke: "#C9D4E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.243 2.39274C19.9908 3.1412 19.7589 4.29676 18.6407 4.9468C17.5568 5.72377 16.7382 6.22279 16.0248 5.60126C15.3576 4.89875 15.8312 3.88107 16.3972 2.70142C17.0212 1.23287 18.449 1.72525 19.243 2.39274Z",
    fill: "#DAE2EB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5688 10.7059C16.5249 10.7146 17.655 9.85664 17.3916 8.63325C17.0939 7.28292 16.9455 6.23242 15.9088 6.17774C14.9526 6.16901 14.8249 6.95471 14.2009 8.42325C13.7961 9.69481 14.4859 10.7322 15.5688 10.7059Z",
    fill: "#DAE2EB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6198 5.44156C14.8625 4.82875 15.5081 4.44573 16.0839 4.55952C16.2913 4.57046 16.5792 4.62735 16.7404 4.71927C17.9608 5.20071 18.6969 6.15708 18.408 6.85086C18.1535 7.67158 16.932 7.94081 15.8383 7.42435C15.516 7.24052 15.3548 7.1486 15.1131 7.01073C14.5952 6.60805 14.3771 6.05436 14.6198 5.44156C14.6198 5.44156 14.666 5.36058 14.6198 5.44156Z",
    fill: "#989FB0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.023 46.1523L96.8917 91.2698C96.3005 91.6393 95.7093 91.9719 95.1181 92.3045C94.0835 92.8957 93.0119 93.413 91.9033 93.9303C90.4622 94.5954 88.9842 95.1867 87.5061 95.704C86.5084 96.0365 85.4738 96.3691 84.4392 96.6647C83.035 97.0342 81.557 97.3668 80.1159 97.6254C79.1182 97.8102 78.1205 97.958 77.1228 98.0689C75.7187 98.2167 74.3515 98.3275 72.9104 98.3645C72.3931 98.3645 71.9127 98.4014 71.3954 98.4014C70.915 98.4014 70.4347 98.4014 69.9543 98.3645C68.661 98.3275 67.4046 98.2536 66.1483 98.1058C65.1506 97.995 64.1529 97.8471 63.1553 97.6993C61.6772 97.4407 60.2361 97.1451 58.832 96.7756C57.7973 96.5169 56.7996 96.1843 55.765 95.8518C54.25 95.3345 52.8089 94.7802 51.3678 94.152C50.2962 93.6717 49.2246 93.1543 48.153 92.6001C47.451 92.2306 46.7858 91.861 46.1207 91.4546L38.7305 47.4456L47.1184 46.1893H104.023V46.1523Z",
    fill: "url(#paint0_linear_234_14552)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4419 94.1526C50.3704 93.6722 49.2988 93.1549 48.2272 92.6006L42.7954 51.9543C42.6845 51.1413 43.2388 50.4023 44.0517 50.2914C44.8646 50.1806 45.6036 50.7349 45.7145 51.5478L51.4419 94.1526Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8691 96.7761C57.8345 96.5174 56.8368 96.1849 55.8022 95.8523L51.7006 51.8803C51.6267 51.0674 52.2179 50.3653 53.0308 50.2914C53.8437 50.2175 54.5828 50.8087 54.6197 51.6216L58.8691 96.7761Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1856 98.1075C65.188 97.9966 64.1903 97.8488 63.1926 97.701L60.9386 51.8445C60.9016 51.0316 61.5298 50.3295 62.3427 50.2926C63.1556 50.2556 63.8577 50.8838 63.8947 51.6967L66.1856 98.1075Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M100.55 51.9525L95.1181 92.3032C94.0834 92.8945 93.0119 93.4118 91.9033 93.9291L97.6308 51.5829C97.7416 50.77 98.4806 50.2157 99.2936 50.3266C100.107 50.4005 100.661 51.1395 100.55 51.9525Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6082 51.9174L87.5435 95.7046C86.5458 96.0372 85.5112 96.3698 84.4766 96.6654L88.689 51.6587C88.7629 50.8458 89.465 50.2546 90.2779 50.3285C91.0908 50.4024 91.719 51.1045 91.6082 51.9174Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4067 51.8445L80.1527 97.6271C79.155 97.8119 78.1574 97.9597 77.1597 98.0705L79.4506 51.6967C79.4876 50.8838 80.1897 50.2556 81.0026 50.2926C81.8155 50.3295 82.4437 51.0316 82.4067 51.8445Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9473 51.7691V98.3646C72.43 98.3646 71.9496 98.4015 71.4323 98.4015C70.9519 98.4015 70.4716 98.4016 69.9912 98.3646V51.7691C69.9912 50.9561 70.6563 50.291 71.4693 50.291C72.3191 50.291 72.9473 50.9561 72.9473 51.7691Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M103.129 50.2161L102.215 53.0273L110.825 55.8256L111.739 53.0144L103.129 50.2161Z",
    fill: "#A9B3C4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7198 50.2212L31.1104 53.0195L32.0241 55.8308L40.6335 53.0325L39.7198 50.2212Z",
    fill: "#A9B3C4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4419 94.1526C50.3704 93.6722 49.2988 93.1549 48.2272 92.6006L42.7954 51.9543C42.6845 51.1413 43.2388 50.4023 44.0517 50.2914C44.8646 50.1806 45.6036 50.7349 45.7145 51.5478L51.4419 94.1526Z",
    fill: "url(#paint1_linear_234_14552)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8692 96.7761C57.8345 96.5174 56.8368 96.1849 55.8022 95.8523L51.7006 51.8803C51.6267 51.0674 52.2179 50.3653 53.0309 50.2914C53.8438 50.2175 54.5828 50.8087 54.6198 51.6216L58.8692 96.7761Z",
    fill: "url(#paint2_linear_234_14552)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1855 98.1063C65.1878 97.9954 64.1901 97.8476 63.1924 97.6998L60.9384 51.8433C60.9015 51.0304 61.5296 50.3283 62.3426 50.2914C63.1555 50.2544 63.8576 50.8826 63.8945 51.6955L66.1855 98.1063Z",
    fill: "url(#paint3_linear_234_14552)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9475 51.7695V98.365C72.4302 98.365 71.9499 98.4019 71.4325 98.4019C70.9522 98.4019 70.4718 98.402 69.9914 98.365V51.7695C69.9914 50.9565 70.6566 50.2914 71.4695 50.2914C72.3194 50.2914 72.9475 50.9565 72.9475 51.7695Z",
    fill: "url(#paint4_linear_234_14552)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4071 51.8433L80.153 97.626C79.1554 97.8107 78.1577 97.9585 77.16 98.0694L79.451 51.6955C79.4879 50.8826 80.19 50.2544 81.0029 50.2914C81.8159 50.3283 82.444 51.0304 82.4071 51.8433Z",
    fill: "url(#paint5_linear_234_14552)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M91.608 51.9173L87.5433 95.7045C86.5456 96.0371 85.511 96.3697 84.4764 96.6653L88.6888 51.6586C88.7627 50.8457 89.4648 50.2545 90.2777 50.3284C91.0907 50.4023 91.7188 51.1044 91.608 51.9173Z",
    fill: "url(#paint6_linear_234_14552)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M100.55 51.9542L95.1183 92.305C94.0837 92.8962 93.0121 93.4135 91.9036 93.9308L97.631 51.5847C97.7419 50.7718 98.4809 50.2175 99.2938 50.3283C100.107 50.4023 100.661 51.1413 100.55 51.9542Z",
    fill: "url(#paint7_linear_234_14552)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_234_14552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.171 47.4443H38.7676C38.0655 47.4443 37.5112 46.8901 37.5112 46.188C37.5112 45.4859 38.0655 44.9316 38.7676 44.9316H104.171C104.873 44.9316 105.428 45.4859 105.428 46.188C105.428 46.8531 104.873 47.4443 104.171 47.4443Z",
    fill: "url(#paint8_linear_234_14552)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_234_14552",
    x: 35.5112,
    y: 44.9316,
    width: 71.9165,
    height: 6.51172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_234_14552"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_234_14552",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_234_14552",
    x1: 71.3821,
    y1: 47.9674,
    x2: 71.3821,
    y2: 77.2943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_234_14552",
    x1: 78.6642,
    y1: 80.2309,
    x2: 80.7343,
    y2: 51.6638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "#7C869B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747D8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_234_14552",
    x1: 78.6642,
    y1: 80.2309,
    x2: 80.7343,
    y2: 51.6638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "#7C869B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747D8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_234_14552",
    x1: 78.6642,
    y1: 80.2309,
    x2: 80.7343,
    y2: 51.6638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "#7C869B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747D8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_234_14552",
    x1: 78.6642,
    y1: 80.2309,
    x2: 80.7343,
    y2: 51.6638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "#7C869B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747D8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_234_14552",
    x1: 78.6642,
    y1: 80.2309,
    x2: 80.7343,
    y2: 51.6638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "#7C869B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747D8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_234_14552",
    x1: 78.6642,
    y1: 80.2309,
    x2: 80.7343,
    y2: 51.6638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "#7C869B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747D8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_234_14552",
    x1: 78.6642,
    y1: 80.2309,
    x2: 80.7343,
    y2: 51.6638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "#7C869B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747D8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_234_14552",
    x1: 71.4473,
    y1: 44.8735,
    x2: 71.4473,
    y2: 47.4714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ADB7C9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCat);
export default __webpack_public_path__ + "static/media/warningCat.d563e4059c8539ea85cc25ff4c50390a.svg";
export { ForwardRef as ReactComponent };